import { createDate, importAll, transformImages } from "utils";

import AcceptanceLetterMain from "../../_hp-acceptance-letter-main";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <ReplicaQuote source="Harry Potter and the Philosopher's Stone">
        ‘Hurry up, boy!’ shouted Uncle Vernon from the kitchen. ‘What are you
        doing, checking for letter-bombs?’ He chuckled at his own joke. Harry
        went back to the kitchen, still staring at his letter. He handed Uncle
        Vernon the bill and the postcard, sat down and slowly began to open the
        yellow envelope.
      </ReplicaQuote>

      <ReplicaParagraph>
        A fully readable, authentic replica of a custom Hogwarts acceptance
        letter. This one is addressed to me - only it arrived over twenty years
        too late, so sadly, no Hogwarts for me. The address is entirely made up
        and doesn’t point to a real place; I just wanted it to sound as
        ridiculous as Harry’s iconic “Cupboard under the Stairs.” Naturally,
        this letter never appeared in the books or films, but it’s closely based
        on Harry’s on-screen version.
      </ReplicaParagraph>

      <AcceptanceLetterMain gallery={transformImages(gallery)} />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
